import {useQuery} from '@tanstack/react-query';
import {GetRefundCitiesParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRefundCities} from '../services/getRefundCities';

export const useGetRefundCitiesQuery = (params: GetRefundCitiesParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.REFUND_CITIES, params],
		queryFn: ({signal}) => getRefundCities({signal, ...params}),
		enabled: false,
	});
